import React, { ReactElement } from 'react'
import { BasePageProps } from '@/globals/pages.types'
import { CourseConfigType } from 'common/src/courseConfig'
import { GetStaticProps } from 'next'
import { EupheusPage } from '@/components/static/EupheusPage/EupheusPage'
import { PageSeo } from '@/components/NextSeo/PageSeo'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'

export const getStaticProps = (async (_context) => {
    return { props: { courseConfigType: CourseConfigType.fsaHealth } }
}) satisfies GetStaticProps<BasePageProps>

const Page = (_props: BasePageProps): ReactElement => {
    return (
        <>
            <PageSeo
                title={
                    'Eupheus: the AI study partner for FSA Group & Health exams'
                }
                description={
                    'Eupheus is the AI study partner built into Just Enough Prep. It answers syllabus questions from your actual course materials, links every source, and autogrades your practice questions — Excel workbooks included.'
                }
                canonicalPath={UiLayoutConstant.EUPHEUS_PAGE}
            />
            <EupheusPage isLoggedIn={false} />
        </>
    )
}

Page.isStatic = true

export default Page
